/*
 * jk-home-poster (7.11, track H, 2026-09-28).
 * 1. Header handoff: while the poster's own navigation row is on screen the
 *    site header stays hidden (CSS in sections/jk-home-poster.liquid). Once the
 *    row has scrolled off the top, body gets .jk-hp-past and the header slides in.
 * 2. Cart count: mirrors the header's count, which the theme updates after
 *    AJAX cart changes, into the poster's "Cart (n)".
 */
(function () {
  const poster = document.querySelector('.jk-hp');
  if (!poster) return;

  if (poster.hasAttribute('data-hide-header')) {
    const nav = poster.querySelector('.jk-hp__nav') || poster;
    const setPast = (past) => document.body.classList.toggle('jk-hp-past', past);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const e = entries[entries.length - 1];
        setPast(!e.isIntersecting && e.boundingClientRect.bottom <= 0);
      });
      io.observe(nav);
    } else {
      setPast(true);
    }
  }

  const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
  const target = poster.querySelector('[data-jk-hp-count]');
  if (source && target) {
    const sync = () => {
      const n = source.textContent.trim();
      if (/^\d+$/.test(n)) target.textContent = n;
      else if (source.querySelector('svg')) target.textContent = '99+';
    };
    new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true });
  }
})();
